export default __webpack_public_path__ + "static/media/map-type.eafc7f21.png";